'use strict'

export function helpService (http) {
	return {
		findHelpById: (helpId) => {
			return http.jsonrpc(
				'/rpc/public/help',
				'findById',
				[ helpId ]
			).then((resp) => {
				return resp.result
			})
		},

		// save a help object
		update: function (helpObject) {
			return http.jsonrpc(
				'/rpc/2.0/help',
				'update',
				[ helpObject ]
			).then(function (resp) {
				return resp.result
			})
		},

		loadFaqCatHelp: (catId) => {
			return http.jsonrpc(
				'/rpc/2.0/help',
				'loadFaqCatHelp',
				[ catId ]
			).then((resp) => {
				return resp.result
			})
		},

		loadFaqCategories: () => {
			return http.jsonrpc(
				'/rpc/2.0/help',
				'loadFaqCategories'
			).then((resp) => {
				return resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/services/help-service.js